import api from './api';
import { User, Teacher, CreateUserData, UpdateUserData } from '../types';

class UserService {
  async getUsers(role?: 'teacher' | 'admin'): Promise<User[]> {
    const params = role ? { role } : {};
    const response = await api.get('/users/', { params });
    // Handle both array and paginated response
    if (Array.isArray(response.data)) {
      return response.data;
    } else if (response.data.results) {
      return response.data.results;
    }
    return [];
  }

  async getUser(id: number): Promise<User> {
    const response = await api.get<User>(`/users/${id}/`);
    return response.data;
  }

  async createUser(data: CreateUserData): Promise<User> {
    const response = await api.post<User>('/auth/register/', data);
    return response.data;
  }

  async updateUser(id: number, data: UpdateUserData): Promise<User> {
    const response = await api.patch<User>(`/users/${id}/`, data);
    return response.data;
  }

  async deleteUser(id: number): Promise<void> {
    await api.delete(`/users/${id}/`);
  }

  async resetPassword(userId: number, newPassword: string): Promise<void> {
    await api.post(`/users/${userId}/reset_password/`, { new_password: newPassword });
  }

  async getTeacherStats(teacherId: number): Promise<Teacher> {
    const response = await api.get<Teacher>(`/users/${teacherId}/stats/`);
    return response.data;
  }

  async searchUsers(query: string): Promise<User[]> {
    const response = await api.get('/users/', {
      params: { search: query }
    });
    // Handle both array and paginated response
    if (Array.isArray(response.data)) {
      return response.data;
    } else if (response.data.results) {
      return response.data.results;
    }
    return [];
  }

  async toggleUserStatus(userId: number, isActive: boolean): Promise<User> {
    const response = await api.patch<User>(`/users/${userId}/`, { is_active: isActive });
    return response.data;
  }
}

const userService = new UserService();
export default userService;